require("../coord/cartesian/AxisModel");

require("./axis/CartesianAxisView");


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/component/axis.js
// module id = 831
// module chunks = 1